import axios from "axios";
import { rootApiUrl } from "../environment/Environment";

export const createOrUpdateTierData = async (tierData) => {
    return axios.post(`${rootApiUrl}/api/v0.2/admin/add-tier-config`, tierData)
};

export const getTierConfigData = async () => {
    return axios.get(`${rootApiUrl}/api/v0.2/admin/get-tier-config`)
};